export const SITE = {
    name: "OM Infra",
    url: "https://ominfra.co",
    tagline: "YEIDA Authority & Semi Commercial (7% Kisan Kota) Plot Specialists",
    phone: "+91 93113 05205",
    phoneHref: "tel:+919311305205",
    whatsapp:
        "https://wa.me/919311305205?text=Hi%20OM%20Infra%2C%20I%27m%20interested%20in%20YEIDA%20plots.%20Please%20share%20details.",
    email: "officialominfra@gmail.com",
    address:
        "OM Infra, Gaur Yamuna City, Sector 19, Greater Noida, Uttar Pradesh 203201",
    hours: "Mon – Sat: 9:30 AM – 6:30 PM",
    rera: "RERA registration details shared on request and on all agreements",
};

export const SOCIALS = [
    { label: "Instagram", url: "https://instagram.com/ominfra.yeida" },
    { label: "Facebook", url: "https://facebook.com/ominfra.yeida" },
    { label: "YouTube", url: "https://youtube.com/@ominfra" },
    { label: "LinkedIn", url: "https://linkedin.com/company/ominfra" },
];

export const OFFICES = [
    {
        name: "Head Office — Gaur Yamuna City",
        address: "OM Infra, Gaur Yamuna City, Sector 19, Greater Noida, Uttar Pradesh 203201",
        geo: { lat: 28.3519, lng: 77.5173 },
        map: "https://www.google.com/maps?q=Gaur+Yamuna+City+Sector+19+Greater+Noida&output=embed",
    },
    {
        name: "Branch Office — Pari Chowk",
        address: "OM Infra, Near Pari Chowk, Greater Noida, Uttar Pradesh 201308",
        geo: { lat: 28.3416, lng: 77.3615 },
        map: "https://www.google.com/maps?q=Pari+Chowk+Greater+Noida&output=embed",
    },
];

export const TESTIMONIALS = [
    {
        name: "Rajesh Tomar",
        location: "Sector 18 Buyer, Noida",
        text: "OM Infra verified every document before I paid a single rupee. PTL, TM and registry were handled end to end — my 300 sqm Authority plot was registered in under two months.",
        rating: 5,
    },
    {
        name: "Sunita Yadav",
        location: "Investor, Delhi NCR",
        text: "As a first-time land buyer I was terrified of plot paperwork. Their team explained the transfer process clearly and found me a registered plot in Sector 20 at a fair price.",
        rating: 5,
    },
    {
        name: "Amit Chauhan",
        location: "NRI Investor, Dubai",
        text: "I bought a 120 sqm plot in Sector 22D entirely remotely. Site videos, demarcation proof and YEIDA no-dues were shared before the token. Genuinely transparent people.",
        rating: 5,
    },
    {
        name: "Vikram Nagar",
        location: "Sector 25 Buyer, Greater Noida",
        text: "Entered the Yamuna Expressway market with a 90 sqm Authority plot at a price I could actually afford. Their pocket-level knowledge is unmatched.",
        rating: 4.5,
    },
];

export const IMAGES = {
    hero: "/assets/img/img-182aa329.webp",
    aerial:
        "/assets/img/img-b90c8de6.webp",
    airport:
        "/assets/img/img-c335606f.webp",
    legal: "/assets/img/img-82faff21.webp",
    signing:
        "/assets/img/img-a4ce4647.webp",
    skyline:
        "/assets/img/img-789958e1.webp",
    masterPlan: "/assets/master-plan-2041.jpg",
    masterPlanWebp: "/assets/master-plan-2041.webp",
    logoWebp: "/assets/om-infra-logo.webp",
};

export const MASTER_PLAN_ALT =
    "YEIDA 2041 Master Plan map showing residential, commercial, industrial, and green zones across the Yamuna Expressway region.";

export const NAV = [
    { label: "Home", to: "/" },
    {
        label: "Authority Plots",
        children: [
            { label: "Complete Guide", to: "/yeida-authority-plots/" },
            { label: "RPS History", to: "/yeida-plot-scheme/" },
            { label: "Plot Sizes", to: "/yeida-authority-plots/#sizes" },
        ],
    },
    {
        label: "Semi Commercial",
        children: [
            { label: "Complete Guide", to: "/kisan-kota-plots/" },
            { label: "Registered", to: "/kisan-kota-plots/#registered" },
            { label: "Unregistered", to: "/kisan-kota-plots/#unregistered" },
            { label: "Semi Commercial vs Authority", to: "/kisan-kota-vs-authority-plots/" },
        ],
    },
    {
        label: "Sectors",
        children: [
            { label: "Residential", to: "/sectors/#residential" },
            { label: "Industrial", to: "/sectors/#industrial" },
            { label: "Semi Commercial", to: "/sectors/#kisan" },
        ],
    },
    { label: "Listings", to: "/listings/" },
    { label: "Development", to: "/development/" },
    { label: "Investor Guide", to: "/investor-guide/" },
    { label: "Blog", to: "/blog/" },
    { label: "Contact", to: "/contact/" },
];

export const PLOT_SIZES = [
    "60 sqm", "90 sqm", "120 sqm", "160 sqm", "162 sqm", "200 sqm", "210 sqm",
    "250 sqm", "300 sqm", "450 sqm", "500 sqm", "1000 sqm", "Not sure",
];

export const SECTOR_OPTIONS = [
    "Sector 8", "Sector 10", "Sector 15", "Sector 16", "Sector 17", "Sector 18",
    "Sector 20", "Sector 22D", "Sector 22E", "Sector 24A", "Sector 25",
    "Sector 29", "Sector 32", "Sector 33", "Sector 34", "Not sure / Need advice",
];

export const PLOT_TYPES = [
    "Authority Plot (Registered)",
    "Authority Plot (Unregistered)",
    "Semi Commercial / Kisan Kota (Registered)",
    "Semi Commercial / Kisan Kota (Unregistered)",
    "Not sure",
];

export const SECTORS = {
    "sector-16": {
        name: "Sector 16",
        slug: "sector-16",
        h1: "YEIDA Sector 16 Plots: Budget Investment Guide 2026",
        metaTitle: "Sector 16 YEIDA Plots — Budget Investment Guide 2026",
        metaDesc:
            "YEIDA Sector 16 plots: budget Authority residential sizes 90–200 sqm on Yamuna Expressway near Jewar Airport. Prices, pockets and investment guide.",
        overview:
            "Sector 16 is the budget entry into YEIDA's Authority residential belt — compact 90 to 200 sqm plots at the corridor's lower price points, suited to first-time buyers who want a notified, bank-loan-eligible plot near the airport zone.",
        sizes: ["90 sqm", "120 sqm", "200 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["Enquire for current semi commercial availability"],
        },
        prices: [
            { label: "Plots under 200 sqm", value: "approx ₹1,00,000 / sqm" },
            { label: "200 sqm and above", value: "₹60,000 – ₹90,000 / sqm" },
        ],
        advantages: [
            "Lowest Authority ticket sizes in the belt",
            "Bank loan eligible on registered plots",
            "Airport influence zone appreciation",
        ],
        infra: [
            "Yamuna Expressway connectivity",
            "Proposed metro corridor",
            "Sector markets and schools nearby",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 16?", a: "Sector 16 primarily offers 90, 120 and 200 sqm Authority residential plots." },
            { q: "Is Sector 16 good for first-time buyers?", a: "Yes — it carries the lowest Authority ticket sizes in the belt, with full registry and bank-loan eligibility on registered plots." },
            { q: "How far is Sector 16 from Jewar Airport?", a: "Sector 16 sits within the airport influence zone on the Yamuna Expressway, a short drive from Noida International Airport." },
        ],
    },
    "sector-17": {
        name: "Sector 17",
        slug: "sector-17",
        h1: "YEIDA Sector 17 Plots: Established Residential Guide 2026",
        metaTitle: "Sector 17 YEIDA Plots — Established Residential Guide 2026",
        metaDesc:
            "YEIDA Sector 17 plots: established residential sector near Jewar Airport with 120–300 sqm Authority plots and registered semi commercial (Kisan Kota) options.",
        overview:
            "Sector 17 is one of the most established residential sectors in YEIDA — adjoining group housing, sector markets and among the closest developed addresses to Noida International Airport. Both Authority plots and registered semi commercial (Kisan Kota) plots trade here with deep resale liquidity.",
        sizes: ["120 sqm", "200 sqm", "300 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["Registered semi commercial pockets — enquire for availability"],
        },
        prices: [
            { label: "Plots under 200 sqm", value: "approx ₹1,00,000 / sqm" },
            { label: "Registered Kisan Kota", value: "₹60,000 – ₹1,00,000 / sqm" },
        ],
        advantages: [
            "Among the closest developed sectors to the airport",
            "Established social infrastructure",
            "Deep resale liquidity",
        ],
        infra: [
            "Noida International Airport (Jewar) nearby",
            "Group housing clusters adjoining",
            "Sector markets operational",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 17?", a: "Sector 17 offers 120, 200 and 300 sqm Authority plots, plus registered semi commercial (Kisan Kota) plots." },
            { q: "Is Sector 17 close to Jewar Airport?", a: "Yes — Sector 17 is among the closest developed residential sectors to Noida International Airport." },
            { q: "Are registered Kisan Kota plots available in Sector 17?", a: "Yes — Sector 17 is one of the five registered semi commercial (Kisan Kota) sectors: 17, 18, 20, 22E and 25." },
        ],
    },
    "sector-24a": {
        name: "Sector 24A",
        slug: "sector-24a",
        h1: "YEIDA Sector 24A Plots: Industrial Corridor Guide 2026",
        metaTitle: "Sector 24A YEIDA Plots — Industrial Corridor Guide 2026",
        metaDesc:
            "YEIDA Sector 24A plots: residential pockets on the industrial corridor edge, 200–500 sqm formats, prices and investment outlook near Jewar Airport.",
        overview:
            "Sector 24A sits on the edge of YEIDA's industrial corridor — residential pockets here price below prime Sectors 18/20 while riding the same industrial demand from the Toy Park, Medical Device Park and logistics belt. Suited to investors with a 3–5 year horizon.",
        sizes: ["200 sqm", "300 sqm", "500 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["Enquire for current semi commercial availability"],
        },
        prices: [
            { label: "200 sqm and above", value: "₹60,000 – ₹90,000 / sqm" },
        ],
        advantages: [
            "Industrial corridor demand driver",
            "Lower entry than prime residential sectors",
            "Larger plot formats available",
        ],
        infra: [
            "Adjoining industrial sectors 28–34",
            "Yamuna Expressway access",
            "Logistics and warehousing belt",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 24A?", a: "Sector 24A offers larger 200, 300 and 500 sqm formats." },
            { q: "Why is Sector 24A cheaper than Sector 18?", a: "It sits on the industrial corridor edge rather than the established residential core — the trade-off is a longer development horizon for a lower entry rate." },
            { q: "Who should buy in Sector 24A?", a: "Investors with a 3–5 year horizon who want industrial-belt demand at residential prices below prime sectors." },
        ],
    },
    "sector-18": {
        name: "Sector 18",
        slug: "sector-18",
        h1: "YEIDA Sector 18 Plots: Complete Investment Guide 2026",
        metaTitle: "Sector 18 YEIDA Plots — Rates, Availability & Investment Guide 2026",
        metaDesc:
            "Complete guide to YEIDA Sector 18 plots — Yamuna Expressway Authority plots in Jewar near Noida International Airport, Greater Noida. Authority plots up to 300 sqm, semi commercial (Kisan Kota) pockets, prices, and investment potential.",
        overview:
            "Sector 18 sits adjacent to the Yamuna Expressway, roughly 20 km from Pari Chowk and 6 km from the Eastern Peripheral Expressway, placing it among the closest developed residential sectors to the Noida International Airport at Jewar. It carries both Authority plots (up to 300 sqm) and the deepest Kisan Kota market in YEIDA.",
        sizes: ["90 sqm", "120 sqm", "162 sqm", "300 sqm"],
        kisan: {
            villages: ["Acheja Bujurg", "Dungarpur"],
            pockets: ["1A", "1B", "2A", "2B", "2C", "3A", "3B", "3C", "3D", "4A", "5A", "5B", "5C", "5D", "6A", "6B", "6C", "6D", "7A", "7B", "7C", "7D", "7E", "7F", "I", "J"],
        },
        prices: [
            { label: "Circle rate", value: "₹36,260 / sqm" },
            { label: "Authority plots (max 300 sqm)", value: "₹60,000 – ₹90,000 / sqm" },
            { label: "Registered Kisan Kota resale", value: "₹60,000 – ₹1,00,000 / sqm" },
            { label: "Example: 300 sqm Authority plot", value: "approx ₹1.80 – ₹2.70 Cr" },
        ],
        advantages: [
            "Proximity to Noida International Airport (Jewar)",
            "Wide roads and planned sector infrastructure",
            "Both Authority and Kisan Kota inventory available",
            "Strong resale demand and deep buyer pool",
        ],
        infra: [
            "Noida International Airport (Jewar)",
            "Film City (Sector 21)",
            "Eastern Peripheral Expressway",
            "Proposed Metro extension",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 18?", a: "Authority plots in Sector 18 go up to 300 sqm. Kisan Kota plots come in 60–1000 sqm across pockets 1A to 7F, I and J." },
            { q: "What is the price of a 300 sqm plot in Sector 18?", a: "A 300 sqm Authority plot in Sector 18 trades around ₹1.80–2.70 crore in 2026 depending on pocket, facing and PLC." },
            { q: "How far is Sector 18 from Jewar Airport?", a: "Sector 18 is among the closest YEIDA residential sectors to the Noida International Airport, with direct connectivity via the Yamuna Expressway." },
            { q: "Is PTL required to buy a resale plot in Sector 18?", a: "Yes. PTL (Permission to Lease) is mandatory before registry for any YEIDA plot transfer in 2026, including Sector 18 resale plots." },
        ],
    },
    "sector-20": {
        name: "Sector 20",
        slug: "sector-20",
        h1: "YEIDA Sector 20 Plots: Complete Investment Guide 2026",
        metaTitle: "Sector 20 YEIDA Plots — Price, Size & Location Guide 2026",
        metaDesc:
            "Complete guide to YEIDA Sector 20 plots — Yamuna Expressway Authority plots in Greater Noida near Jewar Airport. The only Authority-plot sector with 300 to 4000 sqm parcels, plus semi commercial (Kisan Kota) inventory.",
        overview:
            "Sector 20 is YEIDA's large-format plotted sector — the only one where Authority plots run from 300 sqm up to 4000 sqm, on roads from 12 m to 100 m wide. It also holds registered and unregistered Kisan Kota inventory, making it the broadest market on the expressway.",
        sizes: ["300 sqm", "500 sqm", "1000 sqm", "2000 sqm", "4000 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["F", "G", "H", "K", "L", "M", "N", "O", "P"],
        },
        prices: [
            { label: "Circle rate", value: "₹36,260 / sqm" },
            { label: "Authority plots (300–4000 sqm)", value: "₹60,000 – ₹90,000 / sqm" },
            { label: "Example: 500 sqm Authority plot", value: "approx ₹3.00 – ₹4.50 Cr" },
        ],
        advantages: [
            "Only Authority sector with plots up to 4000 sqm",
            "Road widths from 12 m to 100 m",
            "Ideal for builders, institutional buyers and land banking",
            "Registered and unregistered Kisan Kota options",
        ],
        infra: [
            "Noida International Airport (Jewar)",
            "Yamuna Expressway frontage",
            "Film City and Medical Device Park nearby",
            "Proposed Pod Taxi corridor",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 20?", a: "Sector 20 offers Authority plots from 300 to 4000 sqm — the only Authority sector with large parcels — plus Kisan Kota plots in standard sizes." },
            { q: "What does a 500 sqm plot cost in Sector 20?", a: "A 500 sqm Authority plot in Sector 20 runs approximately ₹3.00–4.50 crore in 2026, varying by pocket, road width and PLC." },
            { q: "Which pockets are in Sector 20?", a: "Kisan Kota plots in Sector 20 are located in pockets F, G, H, K, L, M, N, O and P." },
            { q: "Is Sector 20 good for investment?", a: "Yes. Its large-format plots, wide roads and airport proximity give it strong long-term appreciation potential." },
        ],
    },
    "sector-22d": {
        name: "Sector 22D",
        slug: "sector-22d",
        h1: "YEIDA Sector 22D Plots: Complete Investment Guide 2026",
        metaTitle: "Sector 22D Yamuna Expressway Plots — Rates & Guide 2026",
        metaDesc:
            "Complete guide to YEIDA Sector 22D plots near Yamuna Expressway. 120 and 162 sqm plots, prices from ₹1.20 Cr, and investment potential.",
        overview:
            "Sector 22D is a compact, high-utility sector adjoining multi-storey group housing and commercial hubs. With 120 and 162 sqm plot formats, it offers one of the lowest Authority entry tickets in developed YEIDA sectors while keeping buyers close to the airport economy.",
        sizes: ["120 sqm", "162 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["Multiple pockets — enquire for current availability"],
        },
        prices: [
            { label: "Plots under 200 sqm", value: "approx ₹1,00,000 / sqm" },
            { label: "Typical range (120–162 sqm)", value: "₹1.20 – ₹1.62 Cr" },
        ],
        advantages: [
            "Adjoining multi-storey and commercial hubs drive end-user demand",
            "Compact plot sizes suit smaller investors",
            "Authority and Kisan Kota options",
            "Strong rental and resale liquidity",
        ],
        infra: [
            "Noida International Airport (Jewar)",
            "Multi-storey group housing clusters",
            "Commercial hubs and sector markets",
            "Yamuna Expressway connectivity",
        ],
        faqs: [
            { q: "What plot sizes are available in Sector 22D?", a: "Sector 22D primarily offers 120 sqm and 162 sqm plots." },
            { q: "What is the budget for a Sector 22D plot?", a: "Plots under 200 sqm run approximately ₹1,00,000 per sqm, so most Sector 22D plots fall between ₹1.20 and ₹1.62 crore." },
            { q: "Who should buy in Sector 22D?", a: "Smaller investors and end users who want a developed YEIDA address at a lower ticket size." },
            { q: "Is Sector 22D good for end use?", a: "Yes — adjoining group housing and commercial hubs make it one of the most livable plotted sectors." },
        ],
    },
    "sector-25": {
        name: "Sector 25",
        slug: "sector-25",
        h1: "YEIDA Sector 25 Plots: Complete Investment Guide 2026",
        metaTitle: "Sector 25 YEIDA Plots — Complete Guide 2026",
        metaDesc:
            "Complete guide to YEIDA Sector 25 plots near Jewar Airport. Entry-level 60–120 sqm plots, prices, and investment potential.",
        overview:
            "Sector 25 is the entry-level gateway to the YEIDA market, with compact 60 to 120 sqm plots that let first-time investors enter the Jewar Airport growth story at the lowest price points. Both Authority and Kisan Kota formats trade here.",
        sizes: ["60 sqm", "90 sqm", "120 sqm"],
        kisan: {
            villages: ["YEIDA-notified villages (7% Abadi)"],
            pockets: ["Multiple pockets — enquire for current availability"],
        },
        prices: [
            { label: "Plots under 200 sqm", value: "approx ₹1,00,000 / sqm" },
            { label: "Registered Kisan Kota", value: "₹60,000 – ₹1,00,000 / sqm" },
        ],
        advantages: [
            "Lowest entry price among developed YEIDA sectors",
            "Compact sizes ideal for first-time investors",
            "Bank-loan-friendly registered inventory",
            "High percentage appreciation potential near Jewar Airport",
        ],
        infra: [
            "Noida International Airport (Jewar)",
            "Yamuna Expressway access",
            "Planned sector markets and parks",
            "Proposed Metro extension corridor",
        ],
        faqs: [
            { q: "What is the smallest plot available in Sector 25?", a: "Sector 25 offers entry-level plots from 60 sqm." },
            { q: "Is Sector 25 good for first-time investors?", a: "Yes. Its low entry price and airport-driven growth make it the most accessible entry point into YEIDA real estate." },
            { q: "Are small plots loan-eligible?", a: "Registered plots with completed lease deeds are bank-loan eligible regardless of size." },
            { q: "Can I build on a 60 sqm plot?", a: "Yes, subject to YEIDA building byelaws for the sector." },
        ],
    },
};

export const SECTOR_LIST = Object.values(SECTORS);

export const RELATED = {
    kisan: [
        { label: "Sector 18 Plots", to: "/sectors/sector-18/" },
        { label: "Sector 20 Plots", to: "/sectors/sector-20/" },
        { label: "Sector 22D Plots", to: "/sectors/sector-22d/" },
        { label: "Sector 25 Plots", to: "/sectors/sector-25/" },
        { label: "PTL — Permission to Lease", to: "/yeida-rules-2026/ptl-permission-to-lease/" },
        { label: "Transfer Memorandum Process", to: "/yeida-rules-2026/transfer-memorandum-process/" },
        { label: "Transfer Charges & Cost", to: "/yeida-rules-2026/transfer-charges-cost/" },
        { label: "YEIDA Rules 2026", to: "/yeida-rules-2026/" },
    ],
    rules: [
        { label: "PTL — Permission to Lease", to: "/yeida-rules-2026/ptl-permission-to-lease/" },
        { label: "Transfer Memorandum Process", to: "/yeida-rules-2026/transfer-memorandum-process/" },
        { label: "Transfer Charges & Cost", to: "/yeida-rules-2026/transfer-charges-cost/" },
        { label: "7% Kisan Kota Plots Guide", to: "/kisan-kota-plots/" },
        { label: "Available Listings", to: "/listings/" },
    ],
    sectors: [
        { label: "Sector 18", to: "/sectors/sector-18/" },
        { label: "Sector 20", to: "/sectors/sector-20/" },
        { label: "Sector 22D", to: "/sectors/sector-22d/" },
        { label: "Sector 25", to: "/sectors/sector-25/" },
        { label: "All Sectors", to: "/sectors/" },
        { label: "Available Listings", to: "/listings/" },
    ],
};
